import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { syncReducer } from './sync.reducer';

import { SyncService } from './sync.service';
import { UpdateService } from './update.service';

import { PipesModule } from '../../../core/pipes/pipes.module';
import { ButtonModule } from '../../components/button/button.module';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot({
      sync: syncReducer,
    }),
    ButtonModule,
    PipesModule,
  ],
  exports: [],
  providers: [SyncService, UpdateService],
  declarations: [],
})
export class SyncModule {}
